module.exports = __webpack_public_path__ + "static/media/three.1e39bdef.jpg";